import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Constants from "../Utilities/Constants";
import axios from "axios";
import { format } from "date-fns";
import Product from "../Components/Product";
import IngredientsSelector from "../Components/Indegrients";
import { useAppContext } from '../Contexts/AppContext';
import ProductActions from "../Components/ProductActions";
import ProductImage from "../Components/ProductImage";


export default function ProductDetails({layout}) {
    const { productUrl } = useParams();
    const [product, setProduct] = useState(null);
    const [userSelectedUnitId, setUserSelectedUnitId] = useState(null); // Track user unit selection
    const { cart, enrichProduct } = useAppContext(); 

    useEffect(() => {

        const fetchProduct = async () => {
            
            try {
                const url = `${Constants.API_URL_GET_PRODUCT}/${productUrl}`;
                const response = await axios.get(url);
                
                // Enrich the product with units data and cart info
                // Use user-selected unit if available, otherwise default enrichment
                const activeUnitId = userSelectedUnitId || null;
                const enrichedProduct = enrichProduct(response.data, activeUnitId);
                setProduct(enrichedProduct);
            } catch (error) {
                console.error('Error fetching product:', error);
                alert("מוצר לא נמצא");
            }
        };

        fetchProduct();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productUrl, cart, enrichProduct]); // Note: userSelectedUnitId not in deps to avoid conflicts

    /**
     * Handle unit changes from ProductActions component
     * Rebuilds the enriched product with the selected unit as active
     * 
     * @param {number} unitId - ID of the selected unit
     */
    const handleUnitChange = (unitId) => {
        if (unitId !== undefined && unitId !== null) { // Allow unitId 0
            // Remember user's unit selection for future cart updates
            setUserSelectedUnitId(unitId);
            
            if (product && product.id) {
                // Re-fetch and rebuild enriched product with selected unit as active
                const fetchAndUpdateProduct = async () => {
                    try {
                        const url = `${Constants.API_URL_GET_PRODUCT}/${productUrl}`;
                        const response = await axios.get(url);
                        const freshEnrichedProduct = enrichProduct(response.data, unitId);
                        setProduct(freshEnrichedProduct);
                    } catch (error) {
                        console.error('Error re-fetching product for unit change:', error);
                    }
                };
                fetchAndUpdateProduct();
            }
        }
    };


    if (!product) return null;

    return (
        <div className={layout === "modal" ? "product-details-modal" : "product-details-page"}>
            <div className="container py-4">
                <div className="wrapper checkout row" > 
                    <ProductImage 
                        product={product}
                        className="col-md-5"
                        style={{height: 300}}
                        asBackground={true}
                    />
                    <div className="col-md-7 d-flex align-content-around flex-wrap" >
                        <h2 className="border-bottom border-success w-100">{product.productName}</h2>
                        <div>
                            {product.description} 
                            <br />    
                            {product.nutrition} 
                        </div>
                        <div className="w-100">
                            {product.soldout
                            ? <div className="text-danger fs-4">המוצר אזל</div>
                            : <>
                                <div>
                                    {(product.salePrice != null) ? <SalePrice product={product} /> : <ProductPrice product={product} />}
                                    <div>
                                        <span className="text-danger fs-4">{product.notes}</span> &nbsp;
                                        <span>{(product.saleDue != null) ? <span>(בתוקף עד  {format(product.saleDue,'d/MM/yyyy')})</span> : <></>}</span>
                                    </div>
                                </div>
                                <br/>
                                <ProductActions
                                    product={product}
                                    showUnits={true}
                                    showNotes={true}
                                    className="d-flex flex-wrap align-items-center product-page"
                                    onUnitChange={handleUnitChange}
                                />
                              </>
                            }
                            <div className=" flex-wrap" style={{fontSize:12}}>
                                <span>התמונה להמחשה בלבד | </span>
                                <span>כל הנתונים על המוצר עפ"י הגדרות היצרן | </span>
                                <span>מחיר המוצר נשמר בעת סגירת ההזמנה</span>
                            </div>
                            <br/>
                        </div>
                    </div>
                </div>
                    { product.special && product.cart > 0 &&
                        <IngredientsSelector productId={product.id} />
                    }
                    { product && product.relatedProducts && product.relatedProducts.length > 0 &&
                        <>
                        <br/>
                        <h3 className="text-center">אולי יעניין אותך גם...</h3>
                        <br/>
                        <div className="d-flex flex-wrap justify-content-around">
                        
                            {product.relatedProducts.map((item, key) => {
                                return (
                                    <Product product={item} key={key} />
                                )
                            })}
                        </div>
                        </>
                    }
            </div>
        </div>
    )

}


const ProductPrice = ({ product }) => {
    return (
        <>
        <div className="d-flex align-items-end">
            <span className="fw-bold px-1 fs-5">{Number.isInteger(product.price) ? product.price : product.price?.toFixed(2)}</span>
            <span className="unit">ל{product.unit?.unitName}</span>
        </div>
        </>
    );
}

const SalePrice = ({ product }) => {
    return (
        <>
        <div className="d-flex align-items-end">
            <span className="text-decoration-line-through m-1">{Number.isInteger(product.price) ? product.price : product.price.toFixed(2)}</span>
            <span className="fw-bold fs-2 mx-2 text-danger">{Number.isInteger(product.salePrice) ? product.salePrice : product.salePrice.toFixed(2)}</span>
            <span className="unit m-1">₪ ל{product.unit?.unitName}</span>
        </div> 
        </>
    );
}

